import cn from 'classnames';
import { HTMLAttributes } from 'react';

import { ILogo, LogoSize } from './';

const sizeVClasses: Record<LogoSize, string> = {
  large: '188',
  medium: '140',
  small: '94',
};
const sizeHClasses: Record<LogoSize, string> = {
  large: '74',
  medium: '54',
  small: '36',
};

export function Logo(props: ILogo & HTMLAttributes<HTMLElement>) {
  const { layout, forceDarkText, size } = props;

  if (layout === 'horizontal') {
    return (
      <>
        <svg
          width={sizeHClasses[size]}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 648 326"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M552 192C605.019 192 648 149.019 648 96C648 42.9807 605.019 0 552 0C498.981 0 456 42.9807 456 96C456 149.019 498.981 192 552 192ZM552 144C578.51 144 600 122.51 600 96C600 69.4903 578.51 48 552 48C525.49 48 504 69.4903 504 96C504 122.51 525.49 144 552 144Z"
            fill="url(#paint0_linear_107_944)"
          />
          <path
            className={cn(
              forceDarkText ? 'fill-black' : 'fill-black dark:fill-white',
              'duration-500',
            )}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M110.968 268C110.328 264.089 110 260.076 110 256C110 220.654 134.654 190 174 190C213.346 190 238 220.654 238 256C238 260.076 237.672 264.089 237.032 268H214H204.037H143.964C148.176 280.423 158.934 290 174.001 290C182.764 290 190.07 286.76 195.478 281.605L229.168 290.632C218.697 309.212 199.414 322 174.001 322C139.191 322 115.881 298.008 110.969 268H110.968ZM174 222C189.067 222 199.825 231.577 204.037 244H143.963C148.175 231.577 158.933 222 174 222ZM456 256C456 292.451 426.451 322 390 322C353.549 322 324 292.451 324 256C324 219.549 353.549 190 390 190C426.451 190 456 219.549 456 256ZM423 256C423 274.225 408.225 289 390 289C371.775 289 357 274.225 357 256C357 237.775 371.775 223 390 223C408.225 223 423 237.775 423 256ZM246 192H278V200.562C287.414 195.117 298.343 192 310 192C313.402 192 316.742 192.265 320 192.777V225.594C316.854 224.559 313.492 224 310 224C292.327 224 278 238.327 278 256V320H246V256V192ZM102 192H0V224H56L0 288V320H102V288H42L102 224V192Z"
          />
          <defs>
            <linearGradient
              id="paint0_linear_107_944"
              x1="455.759"
              y1="-0.328256"
              x2="648.291"
              y2="192.107"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.078125" stopColor="#F68712" />
              <stop offset="0.239583" stopColor="#F2EF1D" />
              <stop offset="0.494792" stopColor="#F68712" />
              <stop offset="0.854167" stopColor="#BF1B2C" />
              <stop offset="1" stopColor="#BF1B2C" />
            </linearGradient>
          </defs>
        </svg>
      </>
    );
  } else {
    return (
      <>
        <svg
          width={sizeVClasses[size]}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 456 610"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M228 384C334.039 384 420 298.039 420 192C420 85.9613 334.039 0 228 0C121.961 0 36 85.9613 36 192C36 298.039 121.961 384 228 384ZM228 288C281.019 288 324 245.019 324 192C324 138.981 281.019 96 228 96C174.981 96 132 138.981 132 192C132 245.019 174.981 288 228 288Z"
            fill="url(#paint0_linear_107_5)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M110.968 556C110.328 552.089 110 548.076 110 544C110 508.654 134.654 478 174 478C213.346 478 238 508.654 238 544C238 548.076 237.672 552.089 237.032 556H214H204.037H143.964C148.176 568.423 158.934 578 174.001 578C182.764 578 190.07 574.76 195.478 569.605L229.168 578.632C218.697 597.212 199.414 610 174.001 610C139.191 610 115.881 586.008 110.969 556H110.968ZM174 510C189.067 510 199.825 519.577 204.037 532H143.963C148.175 519.577 158.933 510 174 510ZM456 544C456 580.451 426.451 610 390 610C353.549 610 324 580.451 324 544C324 507.549 353.549 478 390 478C426.451 478 456 507.549 456 544ZM423 544C423 562.225 408.225 577 390 577C371.775 577 357 562.225 357 544C357 525.775 371.775 511 390 511C408.225 511 423 525.775 423 544ZM246 480H278V488.562C287.414 483.117 298.343 480 310 480C313.402 480 316.742 480.265 320 480.777V513.594C316.854 512.559 313.492 512 310 512C292.327 512 278 526.327 278 544V608H246V544V480ZM102 480H0V512H56L0 576V608H102V576H42L102 512V480Z"
            className={cn(
              forceDarkText ? 'fill-black' : 'fill-black dark:fill-white',
              'duration-500',
            )}
          />
          <defs>
            <linearGradient
              id="paint0_linear_107_5"
              x1="35.5182"
              y1="-0.656511"
              x2="420.582"
              y2="384.215"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.078125" stopColor="#F68712" />
              <stop offset="0.239583" stopColor="#F2EF1D" />
              <stop offset="0.494792" stopColor="#F68712" />
              <stop offset="0.854167" stopColor="#BF1B2C" />
              <stop offset="1" stopColor="#BF1B2C" />
            </linearGradient>
          </defs>
        </svg>
      </>
    );
  }
}
